import React, { useState } from 'react';
import { useAuth } from '@/context/AuthContext';
import { useFeedData } from '@/hooks/useFeedData';
import Sidebar from '@/components/Sidebar';
import FeedList from '@/components/FeedList';
import { Menu, X } from 'lucide-react';

export default function DashboardPage() {
  const { user } = useAuth();
  const { sources, entries, loadingFeed, loadingSources, refreshing, addSource, deleteSource, refreshFeeds } = useFeedData();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [filterType, setFilterType] = useState('all');

  const filteredEntries = filterType === 'all'
    ? entries
    : entries.filter(e => e.source_type === filterType);

  return (
    <div data-testid="dashboard" className="min-h-screen flex" style={{ backgroundColor: '#FFF0F5' }}>
      <button
        data-testid="mobile-menu-button"
        onClick={() => setSidebarOpen(!sidebarOpen)}
        className="lg:hidden fixed top-4 left-4 z-50 brutalist-btn-primary p-2"
      >
        {sidebarOpen ? <X strokeWidth={2.5} size={20} /> : <Menu strokeWidth={2.5} size={20} />}
      </button>

      {sidebarOpen && (
        <div className="lg:hidden fixed inset-0 bg-black/40 z-40" onClick={() => setSidebarOpen(false)} />
      )}

      <div className={`fixed lg:sticky top-0 left-0 h-screen z-40 transition-transform duration-200 ${sidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}`}>
        <Sidebar
          sources={sources}
          loadingSources={loadingSources}
          onAddSource={addSource}
          onDeleteSource={deleteSource}
          onCloseMobile={() => setSidebarOpen(false)}
        />
      </div>

      <main className="flex-1 min-w-0 p-6 md:p-12 lg:pl-8">
        <FeedList
          entries={filteredEntries}
          loading={loadingFeed}
          refreshing={refreshing}
          onRefresh={refreshFeeds}
          filterType={filterType}
          onFilterChange={setFilterType}
          userName={user?.name}
        />
      </main>
    </div>
  );
}
